import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'

import { store } from 'store'
import { fetchOrganizationSettingsByDomain } from 'store/entities/organizationSettings/actions'
import { getOrganizationLanguage } from 'store/request.js'
import locales from '../locales.json'

const setupI18n = async (language = 'en') => {
  return i18n
    .use(initReactI18next)
    .init({
      lng: language,
      fallbackLng: 'en',
      ns: ['common', 'login', 'user', 'admin'],
      defaultNS: 'common',
      saveMissing: false,
      initImmediate: false,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
        bindI18n: 'languageChanged editorSaved',
      },
      keySeparator: '::',
      resources: locales,
    })
    .then(() => {
      console.log('__i18Init_2nd__')
      moment.locale(language === 'zh' ? 'zh-cn' : language)
    })
    .catch(e => {
      console.log('__i18n_e__', e)
    })
}

export const i18Init = () => {
  console.log('__i18Init__')
  getOrganizationLanguage()
    .then(orgSettingsByDomain => {
      console.log('__i18Init_1st__')
      store.dispatch(fetchOrganizationSettingsByDomain.success(orgSettingsByDomain))
      const language = orgSettingsByDomain.language

      return setupI18n(language)
    })
    .catch(e => {
      console.log("__Looks like organization doesn't_ exists__")
      console.log('__getOrganizationLanguage_e__', e)
      // setup i18n with default language when by-domain request fails
      setupI18n('en')
    })
}
